const state = () => ({
  "engine": null,
  "engine_type": null,
  "emission": null,
  "induction_system": null,
  "after_treatment": null,
  "hw_variant": null,
  "map_date": null,
  "user": null,
  "flash_date": null,
  "engine_runtime": null,
  "ecu_sw_sequence": null,
  "ecu_calibration_id": null,
  "dcu_sw_version": null,
  "dcu_calibration_id": null,
  "engine_load": null,
  "cyl": null,
  "mid": null,
  "ts": null,
  "ts_epoch": null,
  "device_id": null,
  "command": null,

  // 규격정의서 1.05추가
  "map_info":null,
  "vehicleType":null,
  "dhcu_sw_version":null,

  });
  
  const getters = {
    getEngineInfo: (state) => ({
      mid: state.mid,
      ts: state.ts,
      deviceId: state.device_id,
      ts_epoch: state.ts_epoch,
      command: state.command,
      ecu_sw_sequence: state.ecu_sw_sequence,
      ecu_calibration_id: state.ecu_calibration_id,
      dcu_sw_version: state.dcu_sw_version,
      dcu_calibration_id: state.dcu_calibration_id,
      engine: state.engine,
      engine_type: state.engine_type,
      emission: state.emission,
      induction_system: state.induction_system,
      after_treatment: state.after_treatment,
      hw_variant: state.hw_variant,
      map_date: state.map_date,
      user: state.user,
      flash_date: state.flash_date,
      engine_runtime: state.engine_runtime,
      cyl: state.cyl,
      engine_load: state.engine_load,
      // 규격정의서 1.05추가
      vehicleType:state.vehicleType,
      map_info:state.map_info,
      dhcu_sw_version:state.dhcu_sw_version
    }),
  };
  
  const actions = {
    saveVehicleData({ commit }, vehicleData) {
      commit('saveVehicleData', vehicleData);
    },
    clearVehicleData({ commit }) {
      commit('clearVehicleData');
    },
  };
  const mutations = {
    saveVehicleData(state, vehicleData) {
      state.mid = vehicleData.mid;
      state.ts = vehicleData.ts;
      state.device_id = vehicleData.device_id;
      state.command = vehicleData.command;
      state.ts_epoch = vehicleData.ts_epoch;

      state.ecu_sw_sequence = vehicleData.result.ecu_sw_sequence;
      state.ecu_calibration_id = vehicleData.result.ecu_calibration_id;
      state.dcu_sw_version = vehicleData.result.dcu_sw_version;
      state.dcu_calibration_id = vehicleData.result.dcu_calibration_id;
      state.engine = vehicleData.result.engine;
      state.engine_type = vehicleData.result.engine_type;
      state.emission = vehicleData.result.emission;
      state.induction_system = vehicleData.result.induction_system;
      state.after_treatment = vehicleData.result.after_treatment;
      state.hw_variant = vehicleData.result.hw_variant;
      state.map_date = vehicleData.result.map_date;
      state.user = vehicleData.result.user;
      state.flash_date = vehicleData.result.flash_date;
      state.engine_runtime = vehicleData.result.engine_runtime;
      state.cyl = vehicleData.result.cyl;
      state.engine_load = vehicleData.result.engine_load;
      state.map_info = vehicleData.result.map_info;
      state.vehicleType = vehicleData.result.vehicle_type;
      state.dhcu_sw_version = vehicleData.result.dhcu_sw_version;
    },
    clearVehicleData(state) {
      state.mid = null;
      state.ts = null;
      state.ts_epoch = null;
      state.device_id = null;
      state.command = null;
      state.ecu_sw_sequence = null;
      state.ecu_calibration_id = null;
      state.dcu_sw_version = null;
      state.dcu_calibration_id = null;
      state.engine = null;
      state.engine_type = null;
      state.emission = null;
      state.induction_system = null;
      state.after_treatment = null;
      state.hw_variant = null;
      state.map_date = null;
      state.user = null;
      state.flash_date = null;
      state.engine_runtime = null;
      state.cyl = null;
      state.engine_load = null;
      state.vehicleType = null;
      state.map_info = null;
      state.dhcu_sw_version = null;
    }
  };
  
  export default {
    state,
    getters,
    actions,
    mutations,
  };
  